exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.empty-text[data-v-04efb9f8] {\n    color: #999;\n}\n", "", {"version":3,"sources":["E:/ViewUI/src/components/table/cell.vue"],"names":[],"mappings":";AACA;IACI,YAAY;CACf","file":"cell.vue","sourcesContent":["\n.empty-text[data-v-04efb9f8] {\n    color: #999;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-04efb9f8","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/table/cell.vue
// module id = 598
// module chunks = 0